/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {ReaderInstance} from "../models/reader-instance";
import {ReaderService} from "../services/reader.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {PAGING_ITEMS_PER_PAGE} from "../app-constants";
import { PagedResults } from "app/models/paged-results";

@Injectable()
//@Input() KHT - using the @Input() tag breaks certain resolvers after Angular 12 update
export class ReaderInstancesPagingResolver implements Resolve<PagedResults<ReaderInstance>> {

  constructor(
    private mReaderService: ReaderService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PagedResults<ReaderInstance>> {
    try {
      return await this.mReaderService.getAllReaderInstancesForPaging(0, PAGING_ITEMS_PER_PAGE, "ASC", "");
    } catch (error) {
      console.error("Problem resolving Reader Instances... Error: " + error, error);
    }
  }

}
